<section class="vc_row py-5" data-section-luminance="light" *ngIf="pageData['home_about_active'] == 1">
    <div class="container">
        <div class="row d-flex flex-wrap align-items-center">
            <div class="lqd-column col-md-7">
                <h2 class="mt-2 mb-2 font-weight-normal lh-1" *ngIf="pageData['home_about_title']?.trim()"><strong [innerHTML]="pageData['home_about_title']">Where ideas <br>are transformed</strong></h2>
                <p class="h3 font-weight-normal mb-40" *ngIf="pageData['home_about_subtitle']?.trim()"><i [innerHTML]="pageData['home_about_subtitle']">in to business projects.</i></p>
                <p class="font-size-18 lh-15 mb-5 pr-md-4 mb-60" [innerHTML]="pageData['home_about_desc'] | safe: 'html'">RAK SME embraces all national enterpreneurs, providing them with all the support and guidance needed in order to launch their own projects through a number of integrated services, exemptions and facilities. </p>
                <a *ngIf="pageData['home_about_btn_url'] && pageData['home_about_btn_label']" routerLink="/{{pageData['home_about_btn_url']}}" [target]="pageData['home_about_btn_new_window'] ? '_blank' : '_self'" class="btn btn-solid text-uppercase semi-round border-thin font-weight-bold home_about_button">
                    <span class="btn-txt" [innerHTML]="pageData['home_about_btn_label']">Learn More</span>
                </a>
            </div>
            <div class="lqd-column col-md-5">
                <!--
                  One photo. This was a two-image collage: a back image in normal flow
                  set the height and the front photo was laid over it by the theme's
                  parallax script. The back image is a blank white canvas and RAK SME
                  asked for it to go, so the front photo now stands in normal flow.
                -->
                <figure class="home-about-photo mt-4 mt-md-0">
                    <img [src]="pageData['home_about_front_img']" />
                </figure>
            </div>
        </div>
        <div class="col-md-12" style="position: absolute;z-index: -1;bottom: 0;">
            <!-- <img src="../../../../../assets/img/pattern-10.png" style="max-width: 400px;opacity: 0.05;float: left;"> -->
        </div>
    </div>
</section>